import { Route, Routes } from "react-router-dom";
import Collection from "../Collection";
import { PROFILE_COLLECTION_ADD_LINK, PROFILE_COLLECTION_EDIT_LINK } from "../../../../assets/utils/constants";
import CollectionAdd from "../CollectionAdd/CollectionAdd";
import CollectionEdit from "../CollectionEdit/CollectionEdit";

function CollectionRouter() {
    return (
        <Routes>
            <Route index element={<Collection />} />
            <Route path={`${PROFILE_COLLECTION_ADD_LINK}`} element={<CollectionAdd />} />
            <Route path={`${PROFILE_COLLECTION_EDIT_LINK}/:_id`} element={<CollectionEdit />} />
        </Routes>
    );
}

export default CollectionRouter